import React from 'react';

// Line-style nav icons for the left nav — the same inline-SVG pattern (24px box, 1.8 stroke,
// round caps) Ask Paul's sidebar uses, so the two apps' navs read as one family.
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function TraceIcon(props) {
  return (
    <svg {...base} {...props}>
      <rect x="3.5" y="4" width="6" height="5" rx="1.2" />
      <rect x="14.5" y="4" width="6" height="5" rx="1.2" />
      <rect x="14.5" y="15" width="6" height="5" rx="1.2" />
      <path d="M9.5 6.5h5" />
      <path d="M6.5 9v6.5a1 1 0 0 0 1 1h7" />
    </svg>
  );
}

export function TrainingIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M2.5 9 12 4.5 21.5 9 12 13.5Z" />
      <path d="M6.5 11v4.5c0 1.5 2.5 3 5.5 3s5.5-1.5 5.5-3V11" />
      <path d="M21.5 9v5" />
    </svg>
  );
}

export function BomIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 3.5 20.5 8 12 12.5 3.5 8Z" />
      <path d="M3.5 12 12 16.5 20.5 12" />
      <path d="M3.5 16 12 20.5 20.5 16" />
    </svg>
  );
}

export function SparkleIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 3.5c.6 4.2 2.3 5.9 6.5 6.5-4.2.6-5.9 2.3-6.5 6.5-.6-4.2-2.3-5.9-6.5-6.5 4.2-.6 5.9-2.3 6.5-6.5Z" />
      <path d="M18.5 15.5c.2 1.6.9 2.3 2.5 2.5-1.6.2-2.3.9-2.5 2.5-.2-1.6-.9-2.3-2.5-2.5 1.6-.2 2.3-.9 2.5-2.5Z" />
    </svg>
  );
}

// A module this account does not have — shown, but locked.
export function LockIcon(props) {
  return (
    <svg {...base} strokeWidth={2} {...props}>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

export function AccountIcon(props) {
  return (
    <svg {...base} strokeWidth={2} {...props}>
      <path d="M3 21h18M5 21V7l8-4v18M13 21V11l6 3v7M9 9v.01M9 12v.01M9 15v.01" />
    </svg>
  );
}

// Doc Review — a page with a tick, as in the mockup.
export function ReviewIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M6 3h8l4 4v14H6z" />
      <path d="M14 3v4h4" />
      <path d="M9 13l2 2 4-4" />
    </svg>
  );
}

// Risk — a warning triangle, as in the mockup.
export function RiskIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 3l9 16H3z" />
      <path d="M12 10v4" />
      <path d="M12 17h.01" />
    </svg>
  );
}

export function IntegrationsIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4 8h13" />
      <path d="M14 5l3 3-3 3" />
      <path d="M20 16H7" />
      <path d="M10 13l-3 3 3 3" />
    </svg>
  );
}

// Software BOM — a code bracket pair over a package line.
export function SbomIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M8 6l-5 6 5 6" />
      <path d="M16 6l5 6-5 6" />
      <path d="M13.5 5l-3 14" />
    </svg>
  );
}

// DHF — a stack of document pages with a heading line.
export function DhfIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M8 3h9l3 3v13H8z" />
      <path d="M5 6v15h11" />
      <path d="M11 9h6" />
      <path d="M11 13h6" />
    </svg>
  );
}

export const MODULE_ICONS = {
  trace: TraceIcon,
  training: TrainingIcon,
  review: ReviewIcon,
  risk: RiskIcon,
  bom: BomIcon,
  sbom: SbomIcon,
  dhf: DhfIcon,
  integrations: IntegrationsIcon,
};
